export function getUserDetails() {
  const userDetailsKey = process.env.REACT_APP_PUBLIC_USERDETAILS;
  const userDetails = sessionStorage.getItem(userDetailsKey || "userDetails");
  const userData = userDetails ? JSON.parse(userDetails) : {};
  return userData;
}
